<template lang="pug">
.card
	.card-header.bg-success.text-white
		.row
			.col.text-left Cobros
			.col.text-right
				b Total: {{importe | currency('')}} €
	table.table.table-striped.m-0
		thead
			tr
				th Fecha de vencimiento
				th Fecha de emisión
				th Importe
				th
		tbody
			tr(v-for="(recibo, i) in contrato.recibos", :key="recibo.ReciboID")
				td
					datepicker(
						:monday-first="true"
						:bootstrap-styling="true"
						v-model="contrato.recibos[i].FechaVencimiento"
						:disabledDates="MesesBloqueados"
						:disabled="(recibo.Estado === 'Pagado')"
						@input="setFechaEmision(recibo)"
					)
				td
					input.form-control(disabled, :value="recibo.FechaEmision | moment('DD MMM YYYY')")
				td
					input.form-control(
						v-model.number="contrato.recibos[i].ImporteTotal"
						placeholder="Importe"
						:disabled="(recibo.Estado === 'Pagado')"
					)
				td.text-right
					button.btn.btn-danger.btn-block(v-if="recibo.Estado === 'Pendiente'", @click="quitar(recibo)")
						span.fa.fa-trash.mr-2
						| Quitar
		tbody
			tr.bg-white
				td
				td
				td
					b {{ImportePendiente | currency}} pendiente
				td
	.card-body(v-if="variosPorMes")
		.alert.alert-danger
			span.fa.fa-exclamation-triangle.mr-2
			| <b>Atención</b>: has fijado más de un cobro por mes. Normalmente ocurre por error al seleccionar la fecha. No obstante si estás seguro/a de lo que haces puedes continuar
	.card-footer
		button.btn.btn-primary(@click="nuevo")
			| Nuevo
		button.btn.btn-warning.ml-2(@click="repartir")
			| Repartir
		button.btn.btn-dark.ml-2(@click="aplicarFormaDePago", :disabled="!facturacionValida")
			| Aplicar forma de pago
			spana.ml-2(v-if="!facturacionValida") (facturación incorrecta)
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	props: ['contrato', 'importe', 'facturacionValida'],
	created () {
		for (let i = 0; i < this.contrato.recibos.length; i++) {
			if (!this.contrato.ReciboID || !this.contrato.recibos[i].ReciboID.match(/^[0-9]{1,}$/)) {
				this.setFechaEmision(this.contrato.recibos[i])
			}
		}
	},
	computed: {
		...mapGetters({
			permisos: 'permisos/permisos'
		}),
		MesesBloqueados () {
			if (!this.permisos.contratos_ignoraCierre) {
				return {
					to: new Date()
				}
			}
			return {}
		},
		ImportePendiente () {
			let pendiente = Math.round((this.importe - this.totalRecibos) * 100)
			return this.round(pendiente / 100, 2)
		},
		totalRecibos () {
			let importe = 0
			for (let i = 0; i < this.contrato.recibos.length; i++) {
				importe = importe + this.contrato.recibos[i].ImporteTotal
			}
			return this.round(importe, 2)
		},
		variosPorMes () {
			const meses = new Map()

			for (let i = 0; i < this.contrato.recibos.length; i++) {
				if (this.contrato.recibos[i].FechaVencimiento) {
					const fecha = this.contrato.recibos[i].FechaVencimiento
					const mes = fecha.getFullYear().toString() + '-' + fecha.getMonth().toString()

					if (meses.has(mes)) {
						return true
					}

					meses.set(mes, 1)
				}
			}
			return false
		}
	},
	methods: {
		nuevo () {
			let rnd = Math.floor(Math.random() * 10000)
			this.contrato.recibos.push({
				ReciboID: 'recibo-' + rnd + ' - ' + new Date().getTime().toString(),
				FechaVencimiento: null,
				FechaEmision: null,
				ImporteTotal: null,
				Estado: 'Pendiente'
			})
		},
		quitar (recibo) {
			const editor = this.contrato
			editor.recibos = editor.recibos.filter(r => (r !== recibo))
			this.$emit('update:contrato', editor)
		},
		setFechaEmision (recibo) {
			if (!recibo.FechaVencimiento) {
				return null
			}
			if (recibo.FechaEmision && recibo.FechaEmision < new Date()) {
				return recibo.FechaEmision
			}
			let fecha = new Date(recibo.FechaVencimiento.getTime())
			if (this.contrato.partida === 3) {
				// ES SER EMPRESARIOS
				fecha.setDate(15)
			} else {
				fecha.setDate(1)
				fecha.setMonth(fecha.getMonth() + 1)
				fecha.setDate(fecha.getDate() - 1)
			}
			recibo.FechaEmision = fecha
		},
		repartir () {
			/**
			 * Redondeamos a dos decimales
			 */
			if (this.contrato.recibos.length === 0) {
				return
			}

			if (this.importe === 0) {
				return
			}

			// Calculamos el total de recibos que podemos modificar (no están pasados de fecha)
			// TODO: Esta condición debería ser la de que si están cobrados o no
			let totalRecibos = 0
			let importeRestante = this.importe + 0

			for (let i = 0; i < this.contrato.recibos.length; i++) {
				if (this.contrato.recibos[i].Estado === 'Pendiente') {
					totalRecibos++
				} else {
					importeRestante = importeRestante - this.contrato.recibos[i].ImporteTotal
				}
			}

			// Calculamos el importe por meses
			const media = Math.round(importeRestante / totalRecibos * 100)
			let acumulado = 0
			let cantidad = media
			for (let i = 0; i < this.contrato.recibos.length; i++) {
				if (this.contrato.recibos[i].Estado === 'Pendiente') {
					if (i === this.contrato.recibos.length - 1) {
						// Es el último, redondeamos
						cantidad = this.round(importeRestante * 100, 2) - acumulado
					}
					this.contrato.recibos[i].ImporteTotal = this.round(cantidad / 100, 2)
					acumulado = acumulado + cantidad
				}
			}
		},
		aplicarFormaDePago () {
			if (!this.contrato.FormaDePagoID) {
				this.$alert('No has definido una forma de pago')
				return
			}

			this.$http.get('mis-contratos/php/api/get-forma-pago-detalles.php?FormaID=' + this.contrato.FormaDePagoID)
				.then(res => {
					const forma = res.data

					// if (forma.numero_pagos && forma.numero_pagos !== this.contrato.facturacion.length) {
					// 	console.error('No coinciden')
					// 	this.$store.commit('alertas/error', {
					// 		titulo: 'Error',
					// 		mensaje: `La forma de pago seleccionada exige un total de ${forma.numero_pagos} facturas. Ajusta el número de facturas o cambia la forma de pago`
					// 	})
					// 	return
					// }

					this.contrato.recibos = []

					let numeroRecibo = 0
					for (let i = 0; i < this.contrato.facturacion.length; i++) {
						for (let p = 0; p < forma.pagos.length; p++) {
							this.nuevo()
							let dias = forma.pagos[p].Dias
							let milis = new Date(this.contrato.facturacion[i].FechaFactura).getTime()
							milis = milis + dias * 3600000 * 24
							const fecha = new Date(milis)
							this.contrato.recibos[numeroRecibo].FechaVencimiento = fecha
							this.contrato.recibos[numeroRecibo].ImporteTotal = this.round((this.contrato.facturacion[i].ImporteTotal) / forma.pagos.length, 2)
							this.setFechaEmision(this.contrato.recibos[numeroRecibo])
							numeroRecibo++
						}
					}
				})
				.catch(e => {
					console.error(e)
					this.$responseError(e)
				})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/mis-contratos/vue/components/contrato/cobros.vue